import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';

function mapStateToProps({ auth, config }) {
  return {
    consumerHost: config.consumerHost,
    identityHost: config.identityHost,
    isLoggedIn: !!auth.account_id,
  };
}

export default connect(mapStateToProps)(PrivateRoute);
